import { Component, ContentChild, EventEmitter, Input, OnDestroy, Output, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'je-list',
    templateUrl: './list.component.html',
    imports: [NgTemplateOutlet],
})
export class JeListComponent implements OnDestroy {
    public itemsSource: Object[] = [];
    private autoSelectTimeout: ReturnType<typeof setTimeout> | null = null;

    @Input()
    public label: string;

    @Input()
    public disableAutoSelect = false;
    @Output()
    public selectionChanged: EventEmitter<Object> = new EventEmitter<Object>();
    @ContentChild(TemplateRef, { static: true })
    public itemTemplate: TemplateRef<any>;

    @Input()
    public get items(): Object[] {
        return this.itemsSource;
    }

    public set items(value: Object[]) {
        if (value === null || value === undefined) {
            this.itemsSource = [];
        } else {
            this.itemsSource = value;
            this.tryAutoSelectItem();
        }
    }

    public selectItem(newSelectedItem: Object): boolean {
        this.selectionChanged.emit(newSelectedItem);
        return false;
    }

    public ngOnDestroy(): void {
        if (this.autoSelectTimeout !== null) {
            clearTimeout(this.autoSelectTimeout);
            this.autoSelectTimeout = null;
        }
    }

    private tryAutoSelectItem(): void {
        if (!this.disableAutoSelect && this.itemsSource.length === 1) {
            if (this.autoSelectTimeout !== null) {
                clearTimeout(this.autoSelectTimeout);
            }

            this.autoSelectTimeout = setTimeout(() => {
                this.autoSelectTimeout = null;
                if (!this.disableAutoSelect && this.itemsSource.length === 1) {
                    this.selectItem(this.itemsSource[0]);
                }
            });
            return;
        }
    }
}
